import React from "react"
import { Alignment } from "core/alignment"
import Stack from "@kit/design/stack"

export const BasicSetting = ({ editor, node }) => {
  const handleButtonClick = ({ name, value }) => {
    editor.command("setNodeByKey", node.key, {
      data: { ...node.data.toJS(), [name]: value }
    })
  }

  const alignment = node.data.get("alignment") || "left"

  return (
    <div className="flex">
      <Stack spacing={1}>
        <div>
          <Alignment alignment={alignment} onChange={handleButtonClick} />
        </div>
      </Stack>
    </div>
  )
}
